(function () {
  'use strict';

  if (window.LivvewellCradlePodSales && window.LivvewellCradlePodSales.__loaded) return;

  var API = window.LivvewellCradlePodSales || {};
  API.__loaded = true;
  window.LivvewellCradlePodSales = API;

  function qs(root, selector) {
    return root ? root.querySelector(selector) : null;
  }

  function qsa(root, selector) {
    return root ? Array.prototype.slice.call(root.querySelectorAll(selector)) : [];
  }

  function track(name, detail) {
    var payload = detail || {};

    document.dispatchEvent(new CustomEvent(name, {
      bubbles: true,
      detail: payload
    }));

    if (window.dataLayer && Array.isArray(window.dataLayer)) {
      var eventPayload = { event: name };
      Object.keys(payload).forEach(function (key) {
        eventPayload[key] = payload[key];
      });
      window.dataLayer.push(eventPayload);
    }

    if (
      window.Shopify &&
      window.Shopify.analytics &&
      typeof window.Shopify.analytics.publish === 'function'
    ) {
      try {
        window.Shopify.analytics.publish(name, payload);
      } catch (error) {}
    }
  }

  function getVariant(root) {
    var node = qs(root, '[data-lw-cp-variant]');
    if (!node) return null;

    if (node.tagName === 'SELECT') {
      var option = node.options[node.selectedIndex];
      if (!option) return null;

      return {
        id: option.value,
        price: option.dataset.price || '',
        compare: option.dataset.compare || '',
        available: option.dataset.available === 'true',
        image: option.dataset.image || ''
      };
    }

    return {
      id: node.value,
      price: node.dataset.price || '',
      compare: node.dataset.compare || '',
      available: node.dataset.available === 'true',
      image: node.dataset.image || ''
    };
  }

  function updateRoot(root) {
    var variant = getVariant(root);
    if (!variant) return;

  function cleanMoney(value) {
  var temp = document.createElement('div');
  temp.innerHTML = value || '';
  return temp.textContent || temp.innerText || '';
}

qsa(root, '[data-lw-cp-price]').forEach(function (node) {
  node.textContent = cleanMoney(variant.price);
});

qsa(root, '[data-lw-cp-compare]').forEach(function (node) {
  node.textContent = cleanMoney(variant.compare);
  node.hidden = !variant.compare;
});

    var image = qs(root, '[data-lw-cp-image]');
    if (image && variant.image) {
      image.src = variant.image;
      image.removeAttribute('srcset');
    }

    var button = qs(root, '[data-lw-cp-atc]');
    if (button) button.disabled = !variant.available;
  }

  function syncVariant(sourceRoot) {
    var variant = getVariant(sourceRoot);
    var productId = sourceRoot.dataset.productId || '';

    if (!variant || !variant.id || !productId) return;

    qsa(document, '[data-lw-cp-root][data-product-id="' + productId + '"]').forEach(function (root) {
      var node = qs(root, '[data-lw-cp-variant]');

      if (node && node.tagName === 'SELECT') {
        var matchingOption = qsa(node, 'option').find(function (option) {
          return String(option.value) === String(variant.id) && !option.disabled;
        });

        if (matchingOption) node.value = variant.id;
      } else if (node) {
        node.value = variant.id;
      }

      updateRoot(root);
    });

    track('cradlepod_sales_variant_selected', {
      product_id: productId,
      variant_id: variant.id
    });
  }

  function addToCart(root, button) {
    var variant = getVariant(root);
    if (!variant || !variant.id || !variant.available || button.disabled) return;

    var label = qs(root, '[data-lw-cp-atc-label]');
    var errorNode = qs(root, '[data-lw-cp-error]');
    var originalLabel = label ? label.textContent : 'Add to cart';
    var placement = button.dataset.lwCpCtaPlacement || 'unknown';

    track('cradlepod_sales_cta_click', {
      placement: placement,
      product_id: root.dataset.productId || '',
      variant_id: variant.id
    });

    button.disabled = true;
    if (label) label.textContent = 'Adding...';

    if (errorNode) {
      errorNode.hidden = true;
      errorNode.textContent = '';
    }

    var shopRoot =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';

    window.fetch(shopRoot + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: Number(variant.id),
          quantity: 1,
          properties: {
            '_livvewell_cradlepod_sales_page': 'true',
            '_sales_page_cta': placement
          }
        }]
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to add CradlePod to cart.');
        return response.json();
      })
      .then(function () {
        track('cradlepod_sales_add_to_cart', {
          placement: placement,
          product_id: root.dataset.productId || '',
          variant_id: variant.id
        });

        root.dispatchEvent(new CustomEvent('lw:cradlepod:added', {
          bubbles: true,
          detail: {
            placement: placement,
            product_id: root.dataset.productId || '',
            variant_id: variant.id
          }
        }));

        if (label) label.textContent = 'Added';

        window.setTimeout(function () {
          button.disabled = false;
          if (label) label.textContent = originalLabel;

          if (
            window.LivvewellCartDrawer &&
            typeof window.LivvewellCartDrawer.open === 'function'
          ) {
            window.LivvewellCartDrawer.open();
          }
        }, 180);
      })
      .catch(function (error) {
        button.disabled = false;
        if (label) label.textContent = originalLabel;

        if (errorNode) {
          errorNode.textContent =
            error && error.message
              ? error.message
              : 'Unable to add CradlePod. Please try again.';
          errorNode.hidden = false;
        }

        track('cradlepod_sales_add_to_cart_error', {
          placement: placement,
          product_id: root.dataset.productId || ''
        });
      });
  }

  function initProductRoot(root) {
    if (!root || root.dataset.lwCpSalesReady === 'true') return;

    root.dataset.lwCpSalesReady = 'true';

    var variant = qs(root, '[data-lw-cp-variant]');
    var button = qs(root, '[data-lw-cp-atc]');

    if (variant && variant.tagName === 'SELECT') {
      variant.addEventListener('change', function () {
        syncVariant(root);
      });
    }

    if (button) {
      button.addEventListener('click', function () {
        addToCart(root, button);
      });
    }

    updateRoot(root);
  }

  function initSticky() {
    var sticky = qs(document, '[data-lw-cp-sticky]');
    var hero = qs(document, '[data-lw-cp-hero]');
    var finalSection = qs(document, '[data-lw-cp-final]');

    if (!sticky || !hero || sticky.dataset.lwCpStickyReady === 'true') return;
    sticky.dataset.lwCpStickyReady = 'true';

    var heroVisible = true;
    var finalVisible = false;

    function applyState() {
      var visible = !heroVisible && !finalVisible;
      var wasVisible = sticky.classList.contains('is-visible');

      sticky.classList.toggle('is-visible', visible);
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');

      if (visible && !wasVisible) {
        track('cradlepod_sales_sticky_shown', {});
      }
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.target === hero) heroVisible = entry.isIntersecting;
          if (finalSection && entry.target === finalSection) finalVisible = entry.isIntersecting;
        });

        applyState();
      }, { threshold: 0.08 });

      observer.observe(hero);
      if (finalSection) observer.observe(finalSection);
    }
  }

  function initSectionTracking() {
    if (!('IntersectionObserver' in window)) return;

    var sections = qsa(document, '[data-lw-cp-track-section]').filter(function (section) {
      return section.dataset.lwCpTracked !== 'true';
    });

    if (!sections.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.3) return;

        var section = entry.target;
        section.dataset.lwCpTracked = 'true';

        track('cradlepod_sales_section_view', {
          section: section.dataset.lwCpTrackSection || ''
        });

        observer.unobserve(section);
      });
    }, { threshold: [0.3] });

    sections.forEach(function (section) {
      observer.observe(section);
    });
  }

  function initAll(scope) {
    qsa(scope || document, '[data-lw-cp-root]').forEach(initProductRoot);
    initSticky();
    initSectionTracking();
  }

  function boot() {
    initAll(document);

    track('cradlepod_sales_page_view', {
      path: window.location.pathname
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  API.initAll = initAll;
  API.track = track;
})();
